export const setAppTitle = () => {
  const location = window.location.href;
  if (location.includes("localhost")) document.title = "UNIFY PROTO DEV";
  if (location.includes("mvp")) document.title = "CDK Unify (mvp)";
  if (location.includes("chat")) document.title = "CDK Unify (chat)";
  if (location.includes("modern")) document.title = "CDK Unify (modern)";
};
